import { useI18n } from "@/i18n";

/* Title screen v2: real NEW CITIZEN wordmark with cinematic reveal, breathing
   glow, pulsing PRESS ANY KEY, live hub stats strip. */
export function TitleScreen({ stats, settled }) {
  const { t } = useI18n();
  return (
    <div data-testid="menu-title" className="absolute inset-0 flex flex-col items-center justify-center select-none">
      <div style={{ animation: "ncBreathe 3.4s ease-in-out infinite" }} className="flex flex-col items-center px-6">
        <p className="font-mono text-[10px] sm:text-xs tracking-[0.7em] text-[#2E6BFF] uppercase mb-8" style={{ animation: "ncFadeUp 0.8s ease 0.15s both" }}>
          {t("title.presents")}
        </p>
        <div style={{ animation: "ncWordmarkIn 1.1s cubic-bezier(0.16,1,0.3,1) 0.3s both" }}>
          <img
            data-testid="menu-wordmark"
            src="/assets/newcitizen-wordmark.png"
            alt="NEW CITIZEN"
            className="object-contain"
            style={{
              width: "min(76vw, 880px)",
              filter: settled
                ? "drop-shadow(0 0 55px rgba(46,107,255,0.5)) drop-shadow(0 0 140px rgba(255,110,40,0.18))"
                : "drop-shadow(0 0 0px rgba(46,107,255,0))",
              transition: "filter 1.6s ease",
            }}
          />
        </div>
        <div className="flex items-center gap-4 mt-9" style={{ animation: "ncFadeUp 0.8s ease 1.25s both" }}>
          <span className="h-px w-16 sm:w-28 bg-gradient-to-r from-transparent to-[#2E6BFF]/70" />
          <p className="font-mono text-[9px] sm:text-[10px] tracking-[0.55em] text-zinc-400 uppercase text-center">{t("title.tagline")}</p>
          <span className="h-px w-16 sm:w-28 bg-gradient-to-l from-transparent to-[#2E6BFF]/70" />
        </div>
      </div>

      <p data-testid="press-any-key" className="absolute bottom-[22%] font-mono text-xs sm:text-sm tracking-[0.55em] text-zinc-100 uppercase" style={{ animation: "ncPulse 1.1s ease-in-out infinite" }}>
        {t("title.press")}
      </p>
      <p className="absolute bottom-[19.5%] font-mono text-[9px] tracking-[0.4em] text-zinc-500 uppercase" style={{ animation: "ncFadeUp 0.8s ease 1.8s both" }}>{t("title.sound")}</p>

      <div className="absolute bottom-10 inset-x-0 flex items-center justify-center gap-6 font-mono text-[9px] tracking-[0.3em] text-zinc-600 uppercase flex-wrap px-4" style={{ animation: "ncFadeUp 0.8s ease 1.6s both" }}>
        <span data-testid="title-stats-servers">{stats ? t("title.stats_live", { n: stats.online }) : t("menu.linking")}</span>
        <span className="w-1 h-1 bg-zinc-700 rounded-full" />
        <span data-testid="title-stats-players">{stats ? t("title.stats_citizens", { n: stats.players }) : "—"}</span>
        <span className="w-1 h-1 bg-zinc-700 rounded-full" />
        <span>build 4.0.2</span>
      </div>
    </div>
  );
}
